var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("什么时候可以下单？")]),_c('div',{staticClass:"content-info"},[_c('p',{staticClass:"txt1"},[_vm._v("下单时间为：上午8:00-晚上23:00。")])])])
}]

export { render, staticRenderFns }